import React from "react";

export const N_STATUS_ORDER = ["ROZPRACOVANA", "ODESLANA", "SCHVALENA", "ZAMITNUTA", "NAHRAZENA"];
// NAHRAZENA nastavuje server: schválenou verzi přebila novější schválená.
// Kód ODESLANA zůstává kvůli datům, ale nabídka se nikam neposílá — jen se
// dokončí (uzamkne) a čeká na rozhodnutí klienta. Proto „Dokončená".
export const N_STATUS_LABEL = {
  ROZPRACOVANA: "Rozpracovaná", ODESLANA: "Dokončená", SCHVALENA: "Schválená", ZAMITNUTA: "Zamítnutá",
  NAHRAZENA: "Nahrazená",
  // Jen zobrazení (server vrací příznaky u nabídky, ne stav):
  NEVYBRANA: "Nevybraná", NEREALIZOVANA: "Nerealizovaná",
};
export const N_STATUS_PILL = {
  ROZPRACOVANA: "bg-[#eef0f3] text-sec",
  ODESLANA: "bg-[#e8f0fb] text-[#2f6fd0]",
  SCHVALENA: "bg-success-bg text-success",
  ZAMITNUTA: "bg-[#fdecea] text-danger",
  NAHRAZENA: "bg-[#eef0f3] text-muted",
  NEVYBRANA: "bg-[#eef0f3] text-muted",
  NEREALIZOVANA: "bg-[#fdecea] text-danger",
};
// allowed next transitions (mirrors backend)
export const N_TRANSITIONS = {
  ROZPRACOVANA: ["ODESLANA"],
  ODESLANA: ["SCHVALENA", "ZAMITNUTA", "ROZPRACOVANA"],
  ZAMITNUTA: ["ROZPRACOVANA"],
  SCHVALENA: [],
  NAHRAZENA: [],
};

// Stav k zobrazení: varianta, kterou klient nevybral (schválil jinou), a schválená
// nabídka ztracené technologie (klient odstoupil) mají vlastní štítek.
export function nStav(n) {
  if (n.nerealizovana) return "NEREALIZOVANA";
  if (n.nevybrana) return "NEVYBRANA";
  return n.status;
}

export function NStatusPill({ status }) {
  return (
    <span className={`label-up px-2 py-1 rounded-chip ${N_STATUS_PILL[status] || "bg-line text-sec"}`}>
      {N_STATUS_LABEL[status] || status}
    </span>
  );
}
